import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CommonProvider } from '../common';
import { Response } from '../response';

@Injectable()
export class EmployeeRhProvider {
  constructor(public http: HttpClient,
    public commonProvider: CommonProvider) { }

  private _urlQuickLinks: string = this.commonProvider.apiUrl + 'api/v1/quicklink';
  private _urlFiles: string = this.commonProvider.apiUrl + 'api/v1/file';
  private _urlEmployeeRH: string = this.commonProvider.apiUrl + 'api/v1/employeerh';
  private _urlEmployeePRHCI: string = this.commonProvider.apiUrl + 'api/v1/prhci';

  // Get quicklinks
  getQuicklinks(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlQuickLinks + '/list');
  }

  // Get files
  getUserFiles(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlFiles + '/listbycategory');
  }

  downloadUserFile(file_id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlFiles + '/get', { file_id })
  }

  setFileCategory(file_id, categorie): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlFiles + '/setcategory', { file_id, categorie })
  }

  // Employee RH functions

  checkActiveProcess(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlEmployeeRH + '/activeprocess');
  }

  // RHCS
  rhcsSubmitAnswer(datas): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/rhcs/submit', { data: datas })
  }

  // Amazement report
  getAmazementQuestions(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlEmployeeRH + '/amazement/questions');
  }
  amazementSubmitAnswer(datas): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/amazement/submit', { data: datas })
  }

  // Offboarding report
  getOffboardingQuestions(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlEmployeeRH + '/offboarding/content');
  }
  offboardingSubmitAnswer(datas): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/offboarding/submit', { data: datas })
  }

  // Interview

  getUserInterview(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlEmployeeRH + '/interview/get');
  }

  getUserDoneInterviews(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlEmployeeRH + '/interview/getdones');
  }

  getFullInterview(id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/interview/display', { interview_id: id })
  }

  saveUserInterview(datas, goals): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/interview/saveuser', { data: datas, goals: goals })
  }

  saveUserInterviewGoals(interview_id, goals): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/interview/submitgoals', { interview_id: interview_id, goals: goals })
  }

  setUserInterviewDate(interview_id, date): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/interview/setdate', { interview_id: interview_id, date: date })
  }

  // PRHCI interview
  getFullCustomInterview(id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeePRHCI + '/displayInterview', { process_id: id })
  }

  saveUserPRHCIInterviewGoals(process): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeePRHCI + '/createGoals', { process })
  }

  // Skills rating

  getUserSkills(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlEmployeeRH + '/skillsrating/list');
  }

  setUserSkills(answers): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/skillsrating/update', { answers: answers })
  }

  // Custom Interview (PRHCI)

  saveUserCustomInterview(datas): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/prhci/save', { datas })
  }

  saveUserCustomInterviewSignature(datas): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/prhci/saveSignature', { datas })
  }

  // Skills search

  listCustomSkills(): Observable<Response<any>> {
    return this.http.get<Response<any>>(this._urlEmployeeRH + '/customskills/list');
  }

  searchCustomSkillUsers(skills): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/customskills/searchUsers', { skills })
  }

  listManagerTeamSkills(): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/customskills/managerSearch', {})
  }

  // Barometer

  getBarometerCampaignQuestions(barometer_id): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/barometer/getCampaignQuestions', { barometer_id })
  }

  storeBarometerUserAnswers(campaign_id, answers): Observable<Response<any>> {
    return this.http.post<Response<any>>(this._urlEmployeeRH + '/barometer/storeBarometerUserAnswers', { campaign_id, answers })
  }

}




// WEBPACK FOOTER //
// ./src/providers/employeerh/employeerh.ts